import { render, staticRenderFns } from "./share.vue?vue&type=template&id=26a1f2cd&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"
import style0 from "./share.scss?vue&type=style&index=0&id=26a1f2cd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1f2cd",
  null
  
)

export default component.exports